<ion-grid class="ion-padding">
  <ion-row>
    <ion-col size="6">
      <h4 regular class="text-primary-dark-50 ion-no-margin">{{ 'COMPONENTS.NUMBER' | translate }}</h4>
      <h4 regular class="text-primary-dark ion-no-margin"> {{ number }} </h4>
    </ion-col>

    <ion-col size="6">
      <h4 regular class="text-primary-dark-50 ion-no-margin">{{ 'COMPONENTS.READING' | translate }}</h4>
      <h4 regular class="text-primary-dark ion-no-margin"> {{ currentReading }} </h4>
    </ion-col>

    <ion-col size="12">
      <h4 regular class="text-primary-dark-50 ion-no-margin">{{ 'COMPONENTS.STATE' | translate }}</h4>
      <h4 regular class="text-primary-dark ion-no-margin"> {{ conservationState }} </h4>
    </ion-col>
  </ion-row>
</ion-grid>

<div class="divider-dark"></div>

<ion-grid class="ion-padding">
  <ion-row *ngIf="photos.length > 0; else NoPhotos">
    <ion-col size="12">
      <h4 regular class="text-primary-dark-50 ion-no-margin">{{ 'COMPONENTS.PHOTOS' | translate }}</h4>
      <app-photo-gallery
        [canLoad]="false"
        [showButton]="false"
        [canRemove]="false"
        [styleInput]="{ 'padding-left': 0 }"
        [photoArray]="photos"
        [componentId]="this.evaluationSurveyElementItemId"
      ></app-photo-gallery>
    </ion-col>
  </ion-row>
</ion-grid>
<div class="divider"></div>

<ng-template #NoPhotos>
  <h4 regular class="text-primary-dark-50 ion-text-center ion-no-margin">{{
    'COMPONENTS.THERE_ARE_NO_PHOTOS' | translate
  }}</h4>
</ng-template>
